"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8834],{

/***/ 18834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ articleV2; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text = __webpack_require__(4796);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SelectiveSpritesheet.mjs
var SelectiveSpritesheet = __webpack_require__(87583);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChevronDown16.mjs
var ChevronDown16 = __webpack_require__(97425);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(53481);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(9320);
// EXTERNAL MODULE: ./src/components/articles-v2/renderer.tsx
var renderer = __webpack_require__(818);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Container.tsx
var Container = __webpack_require__(93524);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/styles/ComponentTheme.ts
var ComponentTheme = __webpack_require__(12090);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/styles/SharedStyles.ts
var SharedStyles = __webpack_require__(38747);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Typography.tsx
var Typography = __webpack_require__(78837);
// EXTERNAL MODULE: ./src/components/shared/Accordion.tsx
var Accordion = __webpack_require__(41030);
// EXTERNAL MODULE: ./src/components/shared/CardCarouselV2.tsx
var CardCarouselV2 = __webpack_require__(3776);
// EXTERNAL MODULE: ./src/components/shared/Multicard/MulticardCard.tsx
var MulticardCard = __webpack_require__(63933);
;// CONCATENATED MODULE: ./src/components/articles-v2/Multicard.tsx

















var columns = {
    Two: 2,
    Three: 3,
    Four: 4
};
var ArchBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z, {
    target: "e11knl20"
})(function(props) {
    return {
        borderRadius: props.isArched ? "99em 99em 8em 8em" : "24px"
    };
});
var AccordionCardDetails = function(param) {
    var card = param.card, isArched = param.isArched, componentTheme = param.componentTheme, idToDataLoader = param.idToDataLoader;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            ((ref = card.fields.image) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MulticardCard/* CardImage */.xu, {
                isArched: isArched,
                src: (ref3 = card.fields.image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.url,
                alt: ((ref6 = card.fields.image) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.description) || ((ref8 = card.fields.image) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : ref9.title)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectiveSpritesheet/* default */.Z, {
                icons: [
                    ChevronDown16/* default */.Z
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Accordion */.UQ, {
                title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                    display: "grid",
                    gridRow: "1 / -1",
                    gridTemplateRows: "subgrid",
                    rowGap: SharedStyles/* Gutter */.Th,
                    width: "100%",
                    children: [
                        card.fields.eyebrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Eyebrow */.j4, {
                            children: card.fields.eyebrow
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                            as: "h3",
                            color: componentTheme.color,
                            size: "150",
                            fontWeight: "medium",
                            m: "0",
                            children: card.fields.title
                        }),
                        card.fields.subhead && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                            as: "p",
                            color: componentTheme.color,
                            size: "110",
                            fontWeight: "medium",
                            children: card.fields.subhead
                        })
                    ]
                }),
                body: (card === null || card === void 0 ? void 0 : (ref10 = card.fields) === null || ref10 === void 0 ? void 0 : ref10.description) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                    body: card.fields.description,
                    idToLoaderData: idToDataLoader,
                    entryLookup: articleV2
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {})
            })
        ]
    });
};
var CardSectionHeader = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        display: [
            null,
            null,
            "grid"
        ],
        gap: SharedStyles/* Gutter */.Th,
        gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
        mb: 10,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
            __css: (0,_object_spread/* default */.Z)({}, SharedStyles/* StackStyle */.yH),
            gridColumn: "1 / -1",
            children: [
                fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* TitleWithAccent */.aI, {
                    title: fields.title,
                    titleAccent: fields.titleAccent,
                    titleSize: fields.titleSize === "Large" ? [
                        "64px",
                        null,
                        "88px"
                    ] : [
                        "64px"
                    ]
                }),
                (fields.subhead || fields.desc) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                    __css: (0,_object_spread/* default */.Z)({}, SharedStyles/* StackStyle */.yH),
                    maxW: [
                        null,
                        null,
                        "48ch"
                    ],
                    children: [
                        fields.subhead && (fields.titleSize === "Large" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Subhead */.vF, {
                            children: fields.subhead
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* SubheadSmall */.Jm, {
                            children: fields.subhead
                        })),
                        fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Desc */.Xe, {
                            $largerThanLG: {
                                fontSize: 24
                            },
                            children: fields.desc
                        })
                    ]
                })
            ]
        })
    });
};
var RenderMulticard = function(entry, _, context) {
    var fields = entry.fields;
    var idToDataLoader = context === null || context === void 0 ? void 0 : context.idToLoaderData;
    var columnNumber = fields.columns ? columns[fields.columns] : 3;
    var componentTheme = fields.cardBackgroundColor ? (0,ComponentTheme/* getComponentThemeColors */._Y)(fields.cardBackgroundColor) : (0,ComponentTheme/* getComponentThemeColors */._Y)("White 0");
    var isArched = fields.cardStyle === "Arch";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
        gridColumn: "1/-1",
        children: [
            fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSectionHeader, {
                    entry: entry
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardCarouselV2/* default */.Z, {
                id: entry.sys.id,
                cards: fields.cards,
                componentTheme: componentTheme,
                columnNumber: columnNumber,
                isArched: isArched,
                renderCard: function(card) {
                    var ref, ref1, ref2;
                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArchBox, {
                        p: ((ref = card.fields.image) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url) ? "8px 24px 8px" : "88px 24px 24px",
                        background: "#F2F2F2",
                        height: "min-content",
                        isArched: isArched,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionCardDetails, {
                            card: card,
                            componentTheme: componentTheme,
                            isArched: isArched,
                            idToDataLoader: idToDataLoader
                        })
                    });
                }
            })
        ]
    });
};
// https://app.contentful.com/spaces/bjlp9d7o6h1o/content_types/componentMulticard/fields
var Multicard = {
    render: RenderMulticard
};
/* harmony default export */ var articles_v2_Multicard = (Multicard);

// EXTERNAL MODULE: ./src/components/shared/Articles.tsx
var Articles = __webpack_require__(68153);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/List/List.mjs + 1 modules
var List = __webpack_require__(97890);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/List/AccordionListItem.mjs
var AccordionListItem = __webpack_require__(55662);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/ChevronDown.mjs
var ChevronDown = __webpack_require__(18070);
// EXTERNAL MODULE: ./src/components/articles-v2/EmbeddedEntryWrapper.tsx
var EmbeddedEntryWrapper = __webpack_require__(62495);
;// CONCATENATED MODULE: ./src/components/articles-v2/AccordionList.tsx






var renderAccordionList = function(entry) {
    var items = (entry.fields.items || []).map(function(param) {
        var fields = param.fields;
        return {
            title: (fields === null || fields === void 0 ? void 0 : fields.title) || "",
            children: (fields === null || fields === void 0 ? void 0 : fields.body) || "",
            // TODO: team to add unique panelId to fields and use this instead of title
            panelId: (fields === null || fields === void 0 ? void 0 : fields.title) || ""
        };
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectiveSpritesheet/* default */.Z, {
                icons: [
                    ChevronDown/* default */.Z
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
                alignment: "text",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* List */.a, {
                        variant: "accordion",
                        analyticsName: "cosmos-accordionList",
                        width: "100%",
                        children: items.map(function(item) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionListItem/* AccordionListItem */.rB, (0,_object_spread/* default */.Z)({
                                variant: "secondary",
                                wrapText: true
                            }, item), item.panelId);
                        })
                    })
                })
            })
        ]
    });
};
var AccordionList = {
    render: renderAccordionList
};
/* harmony default export */ var articles_v2_AccordionList = (AccordionList);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Link/Link.mjs
var Link = __webpack_require__(47208);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/shared/DynamicTooltip.tsx

// The bricks tooltip needs to attach client-side, not server-side, so we load
// it dynamically to make sure that that happen. If you let it "server-render"
// then the tooltip doesn't work
var DynamicTooltip = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1794).then(__webpack_require__.bind(__webpack_require__, 31794)).then(function(mod) {
        return mod.Tooltip;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    },
    ssr: false
});
/* harmony default export */ var shared_DynamicTooltip = (DynamicTooltip);

;// CONCATENATED MODULE: ./src/components/articles-v2/BasicMetric.tsx




var formatMetric = function(metricValue, metricFormat) {
    switch(metricFormat){
        case "currency":
            // just take whatever is inputted if it's less than 1000
            if (metricValue < 1000) {
                return "$".concat(metricValue);
            }
            return "$".concat(Math.round(metricValue / 1000).toFixed(0), "k");
        case "decimal":
            return metricValue.toLocaleString();
        case "number":
            return metricValue.toLocaleString();
        case "percent":
            return metricValue.toLocaleString("en-US", {
                style: "percent",
                maximumFractionDigits: 3
            });
        default:
            return "".concat(metricValue);
    }
};
var formatSource = function(source) {
    if (!source) {
        return "Opendoor";
    }
    try {
        var url = new URL(source);
        if (!url.protocol.startsWith("http")) {
            return source;
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
            fontSize: "s0",
            href: source,
            analyticsName: "cosmos-articles-basic-metric-source",
            "aria-label": "",
            children: url.host
        });
    } catch (e) {
        return source;
    }
};
var renderBasicMetric = function(entry) {
    var fields = entry.fields;
    if (fields.value === undefined) {
        return null;
    }
    var relativeChange = null;
    if (fields.comparisonValue) {
        // calculate relative to the comparison value, since we want
        // to display the *current* metric with it's relative change
        // x_1	=	initial value
        // x_2	=	final value
        var x1 = fields.comparisonValue;
        var x2 = fields.value;
        relativeChange = (x2 - x1) / x1;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        alignment: "text",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                            mb: "0",
                            mt: "0",
                            fontWeight: "semibold",
                            lineHeight: [
                                "s3",
                                null,
                                null,
                                "s4"
                            ],
                            fontSize: [
                                "s4",
                                null,
                                null,
                                "s5"
                            ],
                            color: "brand50",
                            children: formatMetric(fields.value, fields.format)
                        }),
                        relativeChange !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                            ml: "2",
                            flexDirection: "column",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                    as: "span",
                                    mb: "0",
                                    lineHeight: "s000",
                                    fontSize: [
                                        "s0",
                                        null,
                                        null,
                                        "s1"
                                    ],
                                    textAlign: "left",
                                    children: relativeChange < 0 ? "↓" : "↑"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                    as: "span",
                                    size: "s0",
                                    mt: "0",
                                    lineHeight: "s000",
                                    fontSize: [
                                        "s0",
                                        null,
                                        null,
                                        "s1"
                                    ],
                                    textAlign: "left",
                                    children: [
                                        Math.round(relativeChange * 100).toFixed(0),
                                        "%"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                            mt: "0",
                            mb: "0",
                            children: fields.metricName
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(shared_DynamicTooltip, {
                            label: "Metric info and source information",
                            popupDirection: "bottom",
                            shade: "UNSAFE_light",
                            tooltipIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                fontSize: "s00",
                                children: "ⓘ"
                            }),
                            analyticsName: "cosmos-articles-metric-info-and-source-tooltip",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                    size: "s0",
                                    mb: "0",
                                    mt: "0",
                                    children: [
                                        "Metric: ",
                                        fields.metricDescription
                                    ]
                                }),
                                relativeChange && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                    size: "s0",
                                    mb: "0",
                                    mt: "0",
                                    children: [
                                        "Comparison: ",
                                        fields.comparisonDescription
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                                    size: "s0",
                                    mb: "0",
                                    mt: "0",
                                    children: [
                                        "Source: ",
                                        formatSource(fields.metricSource)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }, fields.metricId || fields.metricName)
    });
};
var BasicMetric = {
    render: renderBasicMetric
};
/* harmony default export */ var articles_v2_BasicMetric = (BasicMetric);

// EXTERNAL MODULE: ./src/components/articles-v2/EmailInput.tsx
var EmailInput = __webpack_require__(41583);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/cms/renderer/index.tsx
var cms_renderer = __webpack_require__(32239);
// EXTERNAL MODULE: ./src/cms/renderer/assets.tsx
var assets = __webpack_require__(23609);
;// CONCATENATED MODULE: ./src/components/articles-v2/HighlightBox.tsx








var renderHighlightBox = function(entry) {
    var ref, ref1, ref2, ref3, ref4;
    var fields = entry.fields;
    var style = {
        default: {
            background: "neutrals40"
        },
        leftBorder: {
            background: "neutrals40",
            borderLeft: "3px solid #ddd"
        },
        dropShadow: {
            background: "neutrals0",
            boxShadow: "z2"
        }
    };
    var ref5, ref6, ref7;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style[fields.variant]), {
            borderRadius: "semiRounded",
            marginY: 9,
            padding: [
                7,
                10,
                null,
                null
            ],
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 6,
            children: [
                fields.image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                    width: (ref5 = (ref = fields.image.fields.file.details.image) === null || ref === void 0 ? void 0 : ref.width) !== null && ref5 !== void 0 ? ref5 : 200,
                    height: "auto",
                    maxWidth: [
                        "100%",
                        "50%",
                        null,
                        null
                    ],
                    flexDirection: "column",
                    alignSelf: "center",
                    children: (0,assets/* default */.ZP)({
                        src: (ref1 = fields.image.fields.file) === null || ref1 === void 0 ? void 0 : ref1.url,
                        contentType: ((ref2 = fields.image.fields.file) === null || ref2 === void 0 ? void 0 : ref2.contentType) || "image/png",
                        width: (ref6 = (ref3 = fields.image.fields.file.details.image) === null || ref3 === void 0 ? void 0 : ref3.width) !== null && ref6 !== void 0 ? ref6 : 200,
                        height: (ref7 = (ref4 = fields.image.fields.file.details.image) === null || ref4 === void 0 ? void 0 : ref4.height) !== null && ref7 !== void 0 ? ref7 : 200
                    })
                }),
                fields.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                    alignItems: "flex-start",
                    flexDirection: "column",
                    flex: 1,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cms_renderer/* default.Component */.Z.Component, {
                        body: fields.content,
                        idToLoaderData: {},
                        entryLookup: articleV2
                    })
                })
            ]
        }))
    });
};
var HighlightBox = {
    render: renderHighlightBox
};
/* harmony default export */ var articles_v2_HighlightBox = (HighlightBox);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(86437);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box_Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var components_Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/fontSizes.mjs
var fontSizes = __webpack_require__(2324);
;// CONCATENATED MODULE: ./src/components/articles-v2/IconText.tsx








var pictureIconSize = fontSizes/* fontSizesNamed.s5 */.gj.s5;
var renderIconText = function(entry) {
    var ref, ref1, ref2, ref3;
    var fields = entry.fields;
    var _obj;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* Box */.x, {
        columnGap: "$1x",
        padding: "$1x",
        flexDirection: "row",
        children: [
            fields.textIcon ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Text/* Text */.x, {
                tag: "p",
                typography: "$headerSmall",
                children: fields.textIcon
            }) : fields.pictureIcon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
                height: pictureIconSize,
                width: pictureIconSize,
                children: (0,assets/* default */.ZP)({
                    src: (ref = fields.pictureIcon.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url,
                    contentType: ((ref2 = fields.pictureIcon.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.file) === null || ref3 === void 0 ? void 0 : ref3.contentType) || "image/png",
                    width: pictureIconSize,
                    height: pictureIconSize
                })
            }),
            fields.labelText && (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(fields.labelText, {
                renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.PARAGRAPH, function(_, children) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyLarge",
                        marginVertical: "auto",
                        marginLeft: "$2x",
                        children: children
                    });
                }), (0,_define_property/* default */.Z)(_obj, dist.INLINES.HYPERLINK, function(node, children) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                        marginLeft: 4,
                        href: node.data.uri,
                        target: "_blank",
                        analyticsName: "cosmos-articles-icon-text",
                        "aria-label": "",
                        children: children
                    });
                }), _obj)
            })
        ]
    });
};
var IconText = {
    render: renderIconText
};
/* harmony default export */ var articles_v2_IconText = (IconText);

;// CONCATENATED MODULE: ./src/components/articles-v2/Iframe.tsx




var IFrame = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("iframe", {
    target: "em7cj9e0"
})("position:absolute;top:0;left:0;width:100%;height:100%;border:0;");
var renderIframe = function(entry) {
    var fields = entry.fields;
    var aspectRatio = fields.ratio ? Math.round(100 / fields.ratio) + "%" : "100%";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
            position: "relative",
            // align in the center on small screens to reduce excess spacing
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            // @ts-expect-error, aspect ratio not supported
            paddingBottom: aspectRatio,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IFrame, {
                title: "contenful-iframe-component",
                src: fields.url,
                allow: "autoplay; fullscreen",
                allowFullScreen: true
            })
        })
    });
};
var IframeComponent = {
    render: renderIframe
};
/* harmony default export */ var Iframe = (IframeComponent);

// EXTERNAL MODULE: ./src/components/articles-v2/ImageAsset.tsx
var ImageAsset = __webpack_require__(54645);
;// CONCATENATED MODULE: ./src/components/articles-v2/ImageAssetLink.tsx




var renderImageLink = function(entry) {
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        alignment: "text",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
            href: entry === null || entry === void 0 ? void 0 : (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.uri,
            target: "_blank",
            analyticsName: "cosmos-articles-image",
            "aria-label": "",
            children: ImageAsset/* default.render */.Z.render(entry.fields.image)
        })
    });
};
var ImageAssetLink = {
    render: renderImageLink
};
/* harmony default export */ var articles_v2_ImageAssetLink = (ImageAssetLink);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/articles-v2/InstagramImage.tsx





// Parameterized instagram embed code, in the future, will use the
// instagram_oembed endpoint from the facebook API.
// You have to ask for permission to use that API by showing the intended
// usage (which we can demonstrate with this embed logic).
// Note: do not edit the styling here (beyond the parameterized url + account)
// this is copied from clicking the "embed" link on a public instagram picture
var getInstaEmbed = function(instagramUrl, account) {
    return '<blockquote class="instagram-media" data-instgrm-permalink="'.concat(instagramUrl, '?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="').concat(instagramUrl, '?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="').concat(instagramUrl, '?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">A post shared by ').concat(account, "</a></p></div></blockquote>");
};
var renderInstagramImage = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        alignment: "text",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    dangerouslySetInnerHTML: {
                        __html: getInstaEmbed(fields.sourceUrl, fields.sourceAccount || "@unkown")
                    },
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".instagram-media{margin-left:auto !important;margin-right:auto !important;}")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                    strategy: "lazyOnload",
                    src: "//www.instagram.com/embed.js"
                }, "instagram-embed")
            ]
        }, fields.sourceUrl)
    });
};
var InstagramImage = {
    render: renderInstagramImage
};
/* harmony default export */ var articles_v2_InstagramImage = (InstagramImage);

;// CONCATENATED MODULE: ./src/components/articles-v2/ImageCarousel.tsx





var renderImageCarousel = function(entry) {
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* Box */.x, {
            overflow: "scroll",
            flexDirection: "row",
            gap: "$10x",
            position: "relative",
            // align in the center on small screens to reduce excess spacing
            alignItems: "center",
            paddingBottom: "$6x",
            paddingRight: "$6x",
            width: "100%",
            $largerThanMD: {
                marginRight: "-10%"
            },
            hoverStyle: {
                shadow: "$default"
            },
            children: (ref = entry.fields.images) === null || ref === void 0 ? void 0 : ref.map(function(x) {
                if (x.sys.contentType.sys.id === "instagramImageAsset") {
                    return articles_v2_InstagramImage.render(x);
                }
                if (x.sys.contentType.sys.id === "imageAsset") {
                    return ImageAsset/* default.render */.Z.render(x);
                }
                return null;
            })
        })
    });
};
var ImageCarouselComponent = {
    render: renderImageCarousel
};
/* harmony default export */ var ImageCarousel = (ImageCarouselComponent);

;// CONCATENATED MODULE: ./src/components/articles-v2/MetricsCard.tsx




var renderMetricsCard = function(entry) {
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        alignment: "text",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
            gridGap: "6",
            pb: "4",
            pt: "4",
            width: "100%",
            flexWrap: [
                "nowrap",
                null,
                "wrap"
            ],
            flexDirection: [
                "column",
                null,
                "row"
            ],
            children: (ref = entry.fields.metrics) === null || ref === void 0 ? void 0 : ref.map(function(x) {
                if (x.sys.contentType.sys.id === "metricBasic") {
                    return articles_v2_BasicMetric.render(x);
                }
                return null;
            })
        })
    });
};
var MetricsCard = {
    render: renderMetricsCard
};
/* harmony default export */ var articles_v2_MetricsCard = (MetricsCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(77668);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Image/Image.mjs
var Image = __webpack_require__(61442);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/eero/foundations/shadows.mjs
var shadows = __webpack_require__(50313);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/components/articles-v2/typography/index.ts
var typography = __webpack_require__(43613);
;// CONCATENATED MODULE: ./src/components/articles-v2/PropertyListings.tsx













var detailTypography = {
    fontSize: [
        "s0",
        null,
        null,
        "s1"
    ],
    fontWeight: "regular",
    lineHeight: [
        "s0",
        null,
        null,
        "s1"
    ]
};
/**
 * Note: this product card attempts to use semantic HTML.
 * The overall structure is:
 * <ul> (entire gallery)
 *   <li> (PropertyCard)
 *     <ul> (attribute list)
 *       <li># Beds
 *       <li># Baths
 *       ...
 *     </ul>
 *     <a><address /></a>
 *   </li>
 *   ...
 * </ul>
 * Each card is a <li> nested under a <ul> when called
 * Attributes are also in a list (with some css to put them inline)
 * The address is in a semantic <address> element
 *
 * The whole card is clickable, but we use an onClick handler for a11y
 * reasons. (only href focuses rather than the whole card focuses)
 *
 */ var PropertyCard = function(props) {
    var ref, ref1;
    var address = "".concat(props.address_line_1, ", ").concat(props.city, ", ").concat(props.state, " ").concat(props.zip);
    // Eventually would like to use imgix to do responsive srcSets
    var ref2 = (0,react.useRef)(null);
    if (!((ref = props.photos[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.cdn_paths) === null || ref1 === void 0 ? void 0 : ref1["480"])) {
        return null;
    }
    // https://images.opendoor.com/source/s3/cabinet-assets/production/storage/a2c50c47-5acb-594f-8ffe-3043a703eb89.jpg
    // /source/s3/cabinet-assets/production/storage/66701bb1-4a14-5c18-9cc8-06ea2f991b84.jpg?service=buyer&token=c0c98583a61dae4735476a51e0c23ccb27aa8b1b7632e4247ad95655b9c64532&w=768
    var srcUrl = null;
    try {
        var parsedSrcUrl = new URL("https://images.opendoor.com".concat(props.photos[0].cdn_paths["480"], "}"));
        // remove params from open_listings and replace with preset params
        parsedSrcUrl.searchParams.delete("service");
        parsedSrcUrl.searchParams.delete("token");
        parsedSrcUrl.searchParams.delete("w");
        parsedSrcUrl.searchParams.set("service", "cosmos");
        parsedSrcUrl.searchParams.set("preset", "3:2-sm");
        srcUrl = parsedSrcUrl.toString();
    } catch (e) {
        esm_exports/* captureException */.Tb(e);
    }
    if (!srcUrl) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
        borderRadius: "semiRounded",
        cursor: "pointer",
        onClick: function() {
            var // navigate here, but don't show on screen-reader
            ref;
            ref2 === null || ref2 === void 0 ? void 0 : (ref = ref2.current) === null || ref === void 0 ? void 0 : ref.click();
        },
        bg: "neutrals0",
        width: [
            "75%",
            "50%",
            "40%",
            "30%"
        ],
        minWidth: [
            "75%",
            "50%",
            "40%",
            "30%"
        ],
        height: [
            "unset",
            null,
            null,
            "20%"
        ],
        minHeight: [
            "unset",
            null,
            null,
            "20%"
        ],
        boxShadow: shadows/* default.z1 */.Z.z1,
        _hover: {
            boxShadow: shadows/* default.z2 */.Z.z2
        },
        as: "li",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                borderTopRadius: "semiRounded",
                overflow: "hidden",
                width: "100%",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                    maxHeight: "640px",
                    maxWidth: "100%",
                    src: srcUrl,
                    alt: "Listing main image"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                p: "4",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        pt: "0",
                        pb: "0",
                        mt: "0",
                        mb: "0"
                    }, typography/* default.h4 */.Z.h4), {
                        children: [
                            "$",
                            props.current_list_price.toLocaleString()
                        ]
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                        style: {
                            listStyle: "none",
                            display: "flex",
                            flexWrap: "wrap",
                            padding: 0
                        },
                        // li + li:before acts like "join" and puts a middot in the middle
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("li + li::before{content:'\\00a0\\00b7\\00a0';}"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                as: "li"
                            }, detailTypography), {
                                children: [
                                    props.bedrooms,
                                    " br"
                                ]
                            })),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                as: "li"
                            }, detailTypography), {
                                children: [
                                    props.bathrooms,
                                    " ba"
                                ]
                            })),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                as: "li"
                            }, detailTypography), {
                                children: [
                                    props.sqft,
                                    " sqft"
                                ]
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                        ref: ref2,
                        "aria-label": "Go to ".concat(address, " detail page"),
                        href: "".concat(globals/* COSMOS_URL */.EQ).concat(props.public_properties_path),
                        analyticsName: "cosmos-articles-pdp-link",
                        onClick: function(e) {
                            e.stopPropagation();
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            as: "address"
                        }, detailTypography), {
                            fontStyle: "normal",
                            children: address
                        }))
                    })
                ]
            })
        ]
    });
};
var renderPropertyListings = function(entry, resolvedData) {
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
            width: [
                "100%",
                null,
                null,
                "100%"
            ],
            marginRight: [
                null,
                null,
                null,
                "-10%"
            ],
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                    style: {
                        listStyle: "none",
                        marginLeft: "0",
                        paddingLeft: "0",
                        paddingBottom: "25px",
                        marginBottom: "10px"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                        position: "relative",
                        flexWrap: [
                            "nowrap",
                            null,
                            null,
                            "wrap"
                        ],
                        gridGap: "9",
                        overflowX: "auto",
                        paddingBottom: "4",
                        paddingLeft: [
                            "4",
                            null,
                            null,
                            "0"
                        ],
                        children: ((ref = resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.properties) !== null && ref !== void 0 ? ref : []).map(function(x) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyCard, (0,_object_spread/* default */.Z)({}, x), x.id);
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                    marginRight: "auto",
                    width: "100%",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                        href: "".concat(globals/* COSMOS_URL */.EQ, "/homes/").concat(resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.mapsBreadcrumb),
                        analyticsName: "cosmos-articles-see-more-".concat(entry.fields.title),
                        "aria-label": "Visit extended ".concat(entry.fields.title),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* default */.Z, {
                            color: "brand50",
                            textDecoration: "underline",
                            children: [
                                "See more ",
                                entry.fields.title
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var propertyListingsLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input) {
        var res, ref, bounds, breadcrumb_path, center, searchParams, propsResult;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!input.fields.zoneId) {
                        return [
                            2,
                            {
                                properties: [],
                                mapsBreadcrumb: null
                            }
                        ];
                    }
                    return [
                        4,
                        fetch("".concat(globals/* BUYER_HOST */.fL, "/zones/").concat(input.fields.zoneId, ".json"))
                    ];
                case 1:
                    res = _state.sent();
                    if (res.status !== 200) {
                        return [
                            2,
                            {
                                properties: [],
                                mapsBreadcrumb: null
                            }
                        ];
                    }
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    ref = _state.sent(), bounds = ref.bounds, breadcrumb_path = ref.breadcrumb_path, center = ref.center;
                    searchParams = new URLSearchParams([
                        [
                            "page",
                            "1"
                        ],
                        [
                            "page_size",
                            "9"
                        ],
                        [
                            "sort",
                            "newest"
                        ]
                    ]);
                    searchParams.set("bounds[north]", "".concat(bounds[0][0]));
                    searchParams.set("bounds[south]", "".concat(bounds[1][0]));
                    searchParams.set("bounds[east]", "".concat(bounds[1][1]));
                    searchParams.set("bounds[west]", "".concat(bounds[0][1]));
                    searchParams.set("location[]", "".concat(center[0]));
                    searchParams.set("location[]", "".concat(center[1]));
                    return [
                        4,
                        fetch("".concat(globals/* BUYER_HOST */.fL, "/zones/").concat(input.fields.zoneId, "/list_properties.json?properties_filter%5Binclude_homebuilder%5D=true&").concat(searchParams.toString()))
                    ];
                case 3:
                    res = _state.sent();
                    if (res.status !== 200) {
                        return [
                            2,
                            {
                                properties: [],
                                mapsBreadcrumb: null
                            }
                        ];
                    }
                    return [
                        4,
                        res.json()
                    ];
                case 4:
                    propsResult = _state.sent();
                    return [
                        2,
                        {
                            properties: propsResult.properties,
                            mapsBreadcrumb: breadcrumb_path || null
                        }
                    ];
            }
        });
    });
    return function propertyListingsLoader(input) {
        return _ref.apply(this, arguments);
    };
}();
var PropertyListingsComponent = {
    render: renderPropertyListings,
    loader: propertyListingsLoader
};
/* harmony default export */ var PropertyListings = (PropertyListingsComponent);

;// CONCATENATED MODULE: ./src/components/articles-v2/Quote.tsx




var Blockquote = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("blockquote", {
    target: "e1fvqkdc0"
})("margin-bottom:0;margin-left:32px;margin-right:0;position:relative;@media (min-width:769px){margin-left:0;}p::before{content:'“';display:inline-block;position:absolute;right:calc(100% + 16px);}");
var renderQuote = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Blockquote, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Text/* Text */.x, {
                tag: "p",
                typography: "$headerMedium",
                children: fields.content
            })
        })
    });
};
var Quote = {
    render: renderQuote
};
/* harmony default export */ var articles_v2_Quote = (Quote);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
;// CONCATENATED MODULE: ./src/components/articles-v2/SimpleCTA.tsx



var renderSimpleCTA = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
        alignment: "text",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* Box */.x, {
            padding: "$10x",
            alignItems: "center",
            backgroundColor: "$backgroundTertiary",
            borderRadius: "$16x",
            flexDirection: "column",
            children: [
                fields.headline && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Text/* Text */.x, {
                    tag: "h5",
                    typography: "$subheaderMedium",
                    textAlign: "center",
                    color: "$contentPrimary",
                    children: fields.headline
                }),
                fields.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Text/* Text */.x, {
                    tag: "p",
                    textAlign: "center",
                    marginVertical: "$5x",
                    typography: "$bodyMedium",
                    $largerThanXS: {
                        typography: "$bodyLarge"
                    },
                    color: "$contentTertiary",
                    children: fields.description
                }),
                fields.ctaLink && fields.ctaText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                    onPress: function() {
                        window.open(fields.ctaLink, "_blank");
                    },
                    analyticsName: "simple-cta-get-offer-button",
                    variant: "primary",
                    size: "small",
                    label: "Get a cash offer"
                })
            ]
        })
    });
};
var SimpleCTA = {
    render: renderSimpleCTA
};
/* harmony default export */ var articles_v2_SimpleCTA = (SimpleCTA);

;// CONCATENATED MODULE: ./src/components/articles-v2/TwitterTweet.tsx




var TweetAnchor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1unfm6n0"
})("color:transparent;");
//https://platform.twitter.com/widgets.js
var RenderTwitterTweet = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                src: "https://platform.twitter.com/widgets.js",
                strategy: "lazyOnload"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedEntryWrapper/* EmbeddedEntryWrapper */.v, {
                alignment: "text",
                display: "flex",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("blockquote", {
                    className: "twitter-tweet",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TweetAnchor, {
                        href: "https://twitter.com/x/status/" + fields.tweetId,
                        children: "Tweet Link"
                    })
                })
            })
        ]
    });
};
var TwitterTweet = {
    render: RenderTwitterTweet
};
/* harmony default export */ var articles_v2_TwitterTweet = (TwitterTweet);

;// CONCATENATED MODULE: ./src/cms/entries/articleV2.ts

















var articleV2EntryLookup = {
    block: {
        componentPropertyListings: PropertyListings,
        componentMetricsCard: articles_v2_MetricsCard,
        componentIconText: articles_v2_IconText,
        componentRelatedArticles: Articles/* default */.ZP,
        metricBasic: articles_v2_BasicMetric,
        ctaEmailCapture: EmailInput/* default */.Z,
        componentImageCarousel: ImageCarousel,
        instagramImageAsset: articles_v2_InstagramImage,
        imageAsset: ImageAsset/* default */.Z,
        componentAccordionList: articles_v2_AccordionList,
        componentImageAssetLink: articles_v2_ImageAssetLink,
        componentIframe: Iframe,
        componentQuotes: articles_v2_Quote,
        componentSimpleCta: articles_v2_SimpleCTA,
        componentTwitter: articles_v2_TwitterTweet,
        componentHighlightBox: articles_v2_HighlightBox,
        componentMulticard: articles_v2_Multicard
    },
    inline: {
        ctaEmailCapture: EmailInput/* default */.Z
    }
};
/* harmony default export */ var articleV2 = (articleV2EntryLookup);


/***/ }),

/***/ 818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71418);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74129);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47208);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(39034);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(68583);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(58528);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(16595);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(67935);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74593);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var cms_renderer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32239);
/* harmony import */ var _cms_renderer_assets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23609);
/* harmony import */ var _components_articles_v2_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43613);
/* harmony import */ var _components_globals__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35480);
/* harmony import */ var _EmbeddedEntryWrapper__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(62495);




















var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var EntryErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(EntryErrorBoundary, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(EntryErrorBoundary);
    function EntryErrorBoundary(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, EntryErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = EntryErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, error, {
            captureContext: {
                extra: {
                    errorInfo: errorInfo,
                    entry: this.props.entry,
                    loaderData: this.props.loaderData
                }
            }
        });
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    };
    EntryErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    };
    return EntryErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
var scrollAnchorStyle = {
    scrollMarginTop: "80px"
};
var RendererComponent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(props) {
    return new RichTextRenderer(props).render();
}, function(prev, next) {
    return Object.entries(prev).every(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
        return lodash_isEqual__WEBPACK_IMPORTED_MODULE_4___default()(v, next[k]);
    });
});
RendererComponent.displayName = "RichTextRenderer";
var isAllText = function(content) {
    return content.every(function(c) {
        return _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.helpers.isText(c);
    });
};
var RichTextRenderer = /*#__PURE__*/ function() {
    "use strict";
    function RichTextRenderer(param) {
        var body = param.body, idToLoaderData = param.idToLoaderData, entryLookup = param.entryLookup;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, RichTextRenderer);
        this.body = body;
        this.idToLoaderData = idToLoaderData;
        this.entryLookup = entryLookup;
        this.options = this.getOption();
        this.generatedIds = {};
    }
    var _proto = RichTextRenderer.prototype;
    _proto.generateId = function generateId(content) {
        if (!isAllText(content)) {
            return null;
        }
        // Type hint, in the "skipId" section, we verified there
        // are only
        var input = content.reduce(function(acc, curr) {
            return acc + curr.value;
        }, "");
        var output = "";
        for(var i = 0; i < input.length; i++){
            var curr = input[i];
            // replace any non word charager with an empty space
            // skip dashes with this
            if (curr === "-") {
                output = output + "-";
                continue;
            }
            // whitespace
            if (curr.match(/\s/)) {
                output = output + "-";
                continue;
            }
            if (curr.match(/\W/)) {
                continue;
            }
            output = output + curr.toLowerCase();
        }
        var id = output.replaceAll(/-+/g, "-");
        // handle duplicates - we'll just increase the appended
        // index if we have a duplicate id
        if (id in this.generatedIds) {
            this.generatedIds[id] += 1;
            id = "".concat(id, "-").concat(this.generatedIds[id]);
        } else {
            this.generatedIds[id] = 0;
        }
        return id;
    };
    _proto.getOption = function getOption() {
        var _this = this;
        var _obj;
        return {
            renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_1, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                    display: "block",
                    tag: "h1",
                    typography: "$subheaderLarge",
                    id: id !== null && id !== void 0 ? id : "",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_2, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                    display: "block",
                    id: id !== null && id !== void 0 ? id : "",
                    typography: "$subheaderMedium",
                    tag: "h2",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_3, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                    display: "block",
                    tag: "h3",
                    typography: "$subheaderSmall",
                    id: id !== null && id !== void 0 ? id : "",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_4, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                    display: "block",
                    tag: "h4",
                    id: id !== null && id !== void 0 ? id : "",
                    typography: "$subheaderXsmall",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.QUOTE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                    tag: "blockquote",
                    borderRadius: 10,
                    marginHorizontal: 0,
                    padding: "$6x",
                    $largerThanMD: {
                        padding: "$10x"
                    },
                    width: "100%",
                    backgroundColor: "$backgroundStateHoverSecondary",
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.block[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ASSET, function(entryData) {
                var ref, ref1, ref2, ref3, ref4;
                var fields = entryData.data.target.fields;
                if (!(0,_cms_renderer_assets__WEBPACK_IMPORTED_MODULE_6__/* .isAsset */ .XL)(fields)) {
                    return null;
                }
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_EmbeddedEntryWrapper__WEBPACK_IMPORTED_MODULE_17__/* .EmbeddedEntryWrapper */ .v, {
                    children: (0,_cms_renderer_assets__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
                        src: (ref = fields.file) === null || ref === void 0 ? void 0 : ref.url,
                        description: fields.description,
                        width: (ref1 = fields.file.details) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.width,
                        height: (ref3 = fields.file.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.height,
                        contentType: fields.file.contentType
                    })
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.inline[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.PARAGRAPH, function(entry, children) {
                var paragraphEntryContent = entry.content;
                if (!Array.isArray(children)) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                        display: "block",
                        tag: "p",
                        typography: "$bodyLarge",
                        children: children
                    });
                }
                // Don't render empty paragraph where the node only contains whitespace text
                var isEmptyParagraph = paragraphEntryContent.length === 1 && paragraphEntryContent[0].nodeType == "text" && typeof paragraphEntryContent[0].value === "string" && paragraphEntryContent[0].value.trim().length === 0;
                if (isEmptyParagraph) {
                    return null;
                }
                var zipped = paragraphEntryContent.map(function(e, i) {
                    return [
                        e,
                        children[i]
                    ];
                });
                var ref = zipped.reduce(function(acc, curr) {
                    var _curr = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(curr, 2), _$entry = _curr[0], child = _curr[1];
                    if (_$entry.nodeType === _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY) {
                        acc.inline = acc.inline.concat(child);
                        return acc;
                    }
                    acc.standard = acc.standard.concat(child);
                    return acc;
                }, {
                    inline: [],
                    standard: []
                }), inline = ref.inline, standard = ref.standard;
                // note: this re-orders the text components, i.e. if you have
                // test <inline entry> test2, it will be rendered as
                // <inline entry> test test2. This doesn't seem ideal, but works
                // for our use-case. We may want to disallow inline embedded entries
                // in the future, and just use the block type.
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .Fragment */ .HY, {
                    children: [
                        inline,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                            display: "block",
                            tag: "p",
                            typography: "$bodyMedium",
                            children: standard
                        })
                    ]
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.HYPERLINK, function(node, children) {
                var target = "_blank";
                if (// https://opendoor.atlassian.net/jira/servicedesk/projects/ENGBUGS/queues/custom/1337/ENGBUGS-47459
                // we want all articles referenced in our articles to open in a new tab
                // we only add production urls to contentful
                !node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_8__/* .COSMOS_URLS.production */ .zu.production + "/articles") && (node.data.uri.startsWith("#") || node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_8__/* .COSMOS_URLS.production */ .zu.production))) {
                    target = "_self";
                }
                var hrefLink = node.data.uri;
                if (node.data.uri.startsWith("#") && node.content[0].nodeType === "text") {
                    var anchorHref = (0,cms_renderer__WEBPACK_IMPORTED_MODULE_5__/* .getLinkForAnchorTagWithId */ ._)(node.content[0].value);
                    hrefLink = anchorHref;
                }
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                    href: hrefLink
                }, _components_articles_v2_typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"].body */ .Z.body), {
                    analyticsName: "cosmos-articles-renderer",
                    "aria-label": "",
                    target: target,
                    children: children
                }));
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_21__/* .Table */ .i, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_22__/* .TableBody */ .R, {
                        children: children
                    })
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_23__/* .TableCell */ .p, {
                    pr: [
                        4,
                        4,
                        5,
                        6
                    ],
                    textAlign: "left",
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_ROW, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_24__/* .TableRow */ .S, {
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_HEADER_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_25__/* .TableHeader */ .x, {
                    pr: [
                        4,
                        4,
                        5,
                        6
                    ],
                    textAlign: "left",
                    children: children
                });
            }), _obj)
        };
    };
    /**
   * Render an entry safely, with Error Boundaries and safe server-side try-catch
   */ _proto.renderEntry = function renderEntry(entryComponent, entryData) {
        var loaderData = this.idToLoaderData[entryData.data.target.sys.id];
        var ref = this, body = ref.body, idToLoaderData = ref.idToLoaderData;
        var component;
        /**
     * Render the entry safely server-side
     */ try {
            component = entryComponent.render(entryData.data.target, loaderData, {
                body: body,
                idToLoaderData: idToLoaderData
            });
        } catch (e) {
            var _obj, ref1;
            (ref1 = (_obj = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability.getSentryClient */ .w.getSentryClient()).captureException) === null || ref1 === void 0 ? void 0 : ref1.call(_obj, e, {
                data: {
                    target: entryData.data.target,
                    loaderData: loaderData
                }
            });
            return null;
        }
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(EntryErrorBoundary, {
            entry: entryData.data.target,
            loaderData: loaderData,
            children: component
        });
    };
    /**
   * Custom memoized rich text renderer, only re-render it at a top-level if the body
   * input has changed (deep diff). Prevents re-renders if something at the top level
   * is misbehaving.
   */ _proto.render = function render() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .Fragment */ .HY, {
            children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__/* .documentToReactComponents */ .h)(this.body, this.options)
        });
    };
    return RichTextRenderer;
}();
RichTextRenderer.Component = RendererComponent;
/* harmony default export */ __webpack_exports__["Z"] = (RichTextRenderer);


/***/ })

}]);